import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['selectAllCheckbox', 'checkbox']

  toggleAll() {
    const checked = this.selectAllCheckboxTarget.checked
    this.checkboxTargets.forEach((cb) => (cb.checked = checked))
  }

  toggleCheckbox() {
    const allChecked = this.checkboxTargets.every((cb) => cb.checked)
    const someChecked = this.checkboxTargets.some((cb) => cb.checked)

    this.selectAllCheckboxTarget.checked = allChecked
    this.selectAllCheckboxTarget.indeterminate = !allChecked && someChecked
  }
}
